import React from "react";
import NcImage from "shared/NcImage/NcImage";
import ProductQuality from "../../../images/about-us/ProductQuality-Blue-Icon.png";
import LargeInventory from "../../../images/about-us/LargeInventory-Blue-Icon.png";
import CustomerService from "../../../images/about-us/CustomerService-Blue-Icon.png";
import TechnicalSupport from "../../../images/about-us/TechnicalSupport-Blue-Icon.png";

const title = `What Makes Us Beyond Brilliant™`;
const description = `We take pride in being a trusted partner, offering consistent, dependable support and expertise at every stage.`;

type Goals = {
  title: string;
  message: string;
  titleImage: string;
};

const goals: Goals[] = [
  {
    title: "Customer Service",
    message:`Fast, bilingual support from a team that’s knowledgeable, approachable, and ready to help, so every interaction feels easy and valuable.`,
    titleImage: CustomerService,
  },
  {
    title: "Large Inventory",
    message:
      "With three warehouses across Canada and a large in-stock inventory, we offer same-day pick-up and fast shipping to keep your projects moving.",
    titleImage: LargeInventory,
  },
  {
    title: "Technical Support",
    message:`Our expert team is here to help with product guidance and lighting layouts, ensuring every installation is efficient and high-performing.`,
    titleImage: TechnicalSupport,
  },
  {
    title: "Product Quality",
    message:`Built for contractors, our durable, high-quality products offer lasting value at fair prices, backed by dependable service at every step.`,
    titleImage: ProductQuality,
  },
];

const AboutUsBeyondBrilliant = () => {
  return (
    <>
      <div className="nc-AboutUsBeyondBrilliant py-12 sm:py-14 px-4 flex flex-col items-center">
        <h1 className="text-4xl md:text-5xl font-semibold text-csccolor text-center mb-4">
          {title}
        </h1>
        <p className="text-lg md:text-xl text-center max-w-2xl">
          {description}
        </p>
      </div>
      <div className="bg-stone-100 grid grid-row-4 sm:grid-cols-4 gap-0 py-5 sm:py-3">
        {goals.map((goal, idx) => (
          <div
            key={idx}
            className={`py-6 px-8 sm:py-10 sm:px-10 flex flex-col items-center justify-center text-center space-y-5`}
          >
            <NcImage
              containerClassName="w-20 h-20"
              className="object-contain w-full h-full"
              src={goal.titleImage}
            />
            <div className={`text-2xl font-bold text-csccolor`}>
              {goal.title}
            </div>
            <div className="">{goal.message}</div>
          </div>
        ))}
      </div>
    </>
  );
};

export default AboutUsBeyondBrilliant;
